export default "__VITE_ASSET__90b8bcc0__"